import { useState, useEffect } from 'react';
import Navbar from '../../pages/home/components/Navbar';
import Footer from '../../pages/home/components/Footer';

interface LayoutProps {
  children: React.ReactNode;
  transparentNav?: boolean;
}

export default function Layout({ children, transparentNav = false }: LayoutProps) {
  const [isScrolled, setIsScrolled] = useState(!transparentNav);

  useEffect(() => {
    if (!transparentNav) {
      setIsScrolled(true);
      return;
    }
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [transparentNav]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      {children}
      <Footer />
    </div>
  );
}
